export const deleteOrderVehicle = (orderVehicleObjectId: any) => {
	return {
		method: "DELETE",
		url: `${process.env.REACT_APP_ORIGIN}/order_vehicles/${orderVehicleObjectId}`
	}
}
